import { MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from 'components/Dialog';
import ConfirmationPopInContent from 'components/Generic/ConfirmationPopInContent';
import { notify } from 'components/Notifier';
import { AppContext } from 'context';
import { generateFixtures } from 'services/apiOperations';
import { DialogWidth } from 'types';

const useStyles = makeStyles(theme => ({
  userMenuItem: {
    paddingLeft: '36px',
  },
}));

const ReloadFixturesMenuItem: React.FC = () => {
  const context = useContext(AppContext);
  const classes = useStyles();

  const [openConfirmFixtures, setOpenConfirmFixtures] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Dialog
        closable={false}
        renderButton={() => {}}
        isOpen={openConfirmFixtures}
        onClose={() => setOpenConfirmFixtures(false)}
        width={DialogWidth.SMALL_FORM}
        renderContent={() => (
          <ConfirmationPopInContent
            title={t('header.fixtures.confirm')}
            cancelText={t('no')}
            validationText={t('yes')}
            cancelAction={() => setOpenConfirmFixtures(false)}
            validateAction={async () => {
              try {
                const p = generateFixtures(context);
                notify({
                  message: t('header.fixtures.loading'),
                  severity: 'info',
                });
                setOpenConfirmFixtures(false);
                await p;

                context.logout();
                notify({
                  message: t('header.fixtures.success'),
                  severity: 'success',
                });
              } catch (e) {
                notify({
                  message: t('errorGeneric'),
                  severity: 'error',
                });
                setOpenConfirmFixtures(false);
              }
            }}
          />
        )}
      />
      <MenuItem className={classes.userMenuItem} onClick={() => setOpenConfirmFixtures(true)}>
        {t('header.loadFixtures')}
      </MenuItem>
    </>
  );
};

export default ReloadFixturesMenuItem;
